<div class="flex flex-col gap-5">
  <h5 class="pl-5 uppercase text-pl-orange-800 sm:pl-0">
    {{ title }}
  </h5>
  <div class="flex flex-col justify-center gap-5 bg-pl-gray-200 p-5">
    <p class="text-lg">{{ text }}</p>
    <pl-button [variant]="ButtonVariant.white" [padding]="ButtonPadding.big" (click)="onButtonClicked()">
      {{ buttonLabel }}
    </pl-button>
  </div>
</div>
